$('.not-logged-in-action').on('mousedown', function() {
    $("#login-mobile-drawer").modal('show');
});